module.exports = fox._r("components/login-wizard/images/icon-sms-success.png", __webpack_public_path__ + "components/login-wizard/images/icon-sms-success.png");


//////////////////
// WEBPACK FOOTER
// ./components/login-wizard/images/icon-sms-success.png
// module id = 120
// module chunks = 5